import { useParams } from "react-router-dom";
import { UserView } from "../features/user";

export const UserPage = () => {
  const prms = useParams();
  const userId = prms.userId ?? "";
  const subscriptionId = prms.subscriptionId ?? "";

  return <UserView subscriptionId={subscriptionId} userId={userId} />;
};
